function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
  let R = 6371; // Radius of the earth in km
  let dLat = deg2rad(lat2 - lat1); // deg2rad below
  let dLon = deg2rad(lon2 - lon1);
  let a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  let d = R * c; // Distance in km
  return d;
}

function deg2rad(deg) {
  return deg * (Math.PI / 180);
}

function updateDealerFE(dealer, scope, km = '') {
  const newDealerBox = document.createElement('div');
  newDealerBox.classList.add('dealer');
  newDealerBox.setAttribute('data-id', dealer.dealerId);
  newDealerBox.setAttribute('data-name', dealer.dealerName);
  newDealerBox.setAttribute('data-address', dealer.dealerAddress);
  if (dealer.dealerExternalId) {
    newDealerBox.setAttribute('data-external-id', dealer.dealerExternalId);
  }

  const name = document.createElement('p');
  name.innerText = dealer.dealerName;
  name.classList.add('name');
  const address = document.createElement('p');
  address.innerText = dealer.dealerAddress;
  address.classList.add('address');
  let kmP = null;
  if (km > -1) {
    kmP = document.createElement('p');
    kmP.innerText = 'Distanza: ' + (km >= 1 ? km : 1.0) + 'km';
    kmP.classList.add('km');
    newDealerBox.setAttribute('data-km', km);
  }
  scope.appendChild(newDealerBox);
  newDealerBox.appendChild(name);
  newDealerBox.appendChild(address);
  if (kmP) {
    newDealerBox.appendChild(kmP);
  }
  newDealerBox.addEventListener('click', (e) => {
    //deselect all first

    scope.querySelectorAll('div').forEach((boxDealer) => {
      if (
        boxDealer.classList.contains('active') &&
        e.currentTarget !== boxDealer
      ) {
        boxDealer.classList.remove('active');
      }
    });
    e.currentTarget.classList.toggle('active');
    e.currentTarget.classList.contains('active')
      ? e.currentTarget.parentNode.setAttribute(
          'data-dealer-id',
          e.currentTarget.getAttribute('data-id'),
        )
      : e.currentTarget.parentNode.removeAttribute('data-dealer-id');
    e.currentTarget.classList.contains('active')
      ? e.currentTarget.parentNode.setAttribute(
          'data-dealer-name',
          e.currentTarget.querySelector('.name').innerText,
        )
      : e.currentTarget.parentNode.removeAttribute('data-dealer-name');
    e.currentTarget.classList.contains('active')
      ? e.currentTarget.parentNode.setAttribute(
          'data-dealer-address',
          e.currentTarget.querySelector('.address').innerText,
        )
      : e.currentTarget.parentNode.removeAttribute('data-dealer-address');
    if (e.currentTarget.getAttribute('data-external-id')) {
      e.currentTarget.classList.contains('active')
        ? e.currentTarget.parentNode.setAttribute(
            'data-dealer-external-id',
            e.currentTarget.getAttribute('data-external-id'),
          )
        : e.currentTarget.parentNode.removeAttribute('data-dealer-external-id');
    }

    if (scope.classList.contains('dealer-container-related')) {
      e.currentTarget.classList.contains('active')
        ? e.currentTarget.parentNode.parentNode.parentNode
            .querySelector('.cta-invia-preventivo')
            .classList.remove('disabled')
        : e.currentTarget.parentNode.parentNode.parentNode
            .querySelector('.cta-invia-preventivo')
            .classList.add('disabled');
    } else {
      checkIfCanSendLead();
    }
  });
}

function controlLocation(dealersPoints, loc) {
  const latitude = loc.lat;
  const longitude = loc.lon;
  const km = getDistanceFromLatLonInKm(
    dealersPoints[0],
    dealersPoints[1],
    latitude,
    longitude,
  );
  if (km <= 500) {
    return km;
  }
  return -1;
}

function onResponseDealer(response) {
  const idBrand = sessionStorage.getItem('id_brand');
  if (response.msg) {
    document
      .querySelector('.form-lead')
      .setAttribute('data-dealer-mandatory', 'false');
  } else {
    document
      .querySelector('.form-lead')
      .setAttribute('data-dealer-mandatory', 'false');
    if (sessionStorage.getItem('geocode')) {
      const listDealers = sessionStorage.getItem(
        'all_dealers_brand_' + idBrand,
      );
      if (!listDealers) {
        sessionStorage.setItem(
          'all_dealers_brand_' + idBrand,
          JSON.stringify(response),
        );
      }
      callApi({
        uri:
          'https://nominatim.openstreetmap.org/search?postalcode=' +
          sessionStorage.getItem('request_cap') +
          '&countrycodes=IT&format=json',
        method: 'GET',
      }).then((resJson) => {
        resJson.json().then((result) => {
          {
            result.forEach((loc) => {
              if (
                loc.display_name.indexOf(
                  sessionStorage.getItem('request_cap'),
                ) > -1
              ) {
                const scopes = document.querySelectorAll('.dealer-container');
                if (scopes.length > 0) {
                  const orderedDealers = [];
                  scopes.forEach((scope) => {
                    scope.classList.remove('active');
                    if (scope.querySelectorAll('div').length > 0) {
                      scope.querySelectorAll('div').forEach((boxDealerOld) => {
                        boxDealerOld.parentNode.removeChild(boxDealerOld);
                      });
                    }
                    document
                      .querySelector('.form-lead')
                      .setAttribute('data-dealer-mandatory', 'true');
                    checkIfCanSendLead();

                    if (
                      document
                        .querySelector('.form-lead')
                        .getAttribute('data-dealer-mandatory') &&
                      document
                        .querySelector('.form-lead')
                        .getAttribute('data-dealer-mandatory') === 'true'
                    ) {
                      document
                        .querySelector('.form-lead')
                        .querySelector('.select_dealer_label')
                        .classList.add('active');
                    }

                    if (orderedDealers.length === 0) {
                      const list = sessionStorage.getItem(
                        'all_dealers_brand_' +
                          sessionStorage.getItem('id_brand'),
                      );
                      if (list) {
                        JSON.parse(list).data.forEach((dealer) => {
                          if (dealer.dealerGeocodedPoints) {
                            const dealersPoints =
                              dealer.dealerGeocodedPoints.split(',');
                            if (dealersPoints.length == 2) {
                              const km = controlLocation(dealersPoints, loc);
                              if (km >= 0) {
                                orderedDealers.push({ ...dealer, km });
                              }
                            }
                          }
                        });
                      }
                    }

                    if (orderedDealers.length > 0) {
                      orderedDealers.sort((a, b) => {
                        if (a.km > b.km) {
                          return 1;
                        } else if (a.km < b.km) {
                          return -1;
                        } else {
                          return 0;
                        }
                      });
                      orderedDealers.forEach((dealer) =>
                        updateDealerFE(dealer, scope, dealer.km.toFixed(2)),
                      );
                    }
                    scope.classList.toggle('active');
                  });
                }
              }
            });
            if (result.length === 0) {
              const notification = document.querySelector(
                '.notification-component',
              );
              notification.querySelector('.title').innerText = 'Errore';
              notification.querySelector('.description').innerText =
                'CAP non valido';
              notification.classList.add('notification-component--error');
              notification.classList.add('active');
            }
            sessionStorage.removeItem('request_cap');
            sessionStorage.removeItem('id_brand');
          }
        });
        sessionStorage.removeItem('geocode');
        document
          .querySelector('.form-lead')
          .querySelector('.loader')
          .classList.remove('active');
      });
    } else {
      const scopes = document.querySelectorAll('.dealer-container');
      if (scopes.length > 0) {
        scopes.forEach((scope) => {
          scope.classList.remove('active');
          if (scope.querySelectorAll('div').length > 0) {
            scope.querySelectorAll('div').forEach((boxDealerOld) => {
              boxDealerOld.parentNode.removeChild(boxDealerOld);
            });
          }
          document
            .querySelector('.form-lead')
            .setAttribute('data-dealer-mandatory', 'true');
          checkIfCanSendLead();
          //updateDealerFE(dealer, scope);
        });
      }
      document
        .querySelector('.form-lead')
        .querySelector('.loader')
        .classList.remove('active');
    }
  }
}

function getDealerList(idBrand, cap, geocode = false) {
  const dealerError = document
    .querySelector('.form-lead')
    .querySelector('.dealer-locator-error-container');
  if (dealerError) {
    dealerError.classList.add('hide');
  }
  document
    .querySelector('.form-lead')
    .querySelector('.loader')
    .classList.add('active');
  let uri = '';
  if (geocode !== 'true') {
    uri =
      '/api/lead/getDealerList/' +
      idBrand +
      '/' +
      cap +
      '/' +
      forceSchedule +
      '?_format=json';
  } else {
    sessionStorage.setItem('geocode', geocode);
    sessionStorage.setItem('request_cap', cap);
    sessionStorage.setItem('id_brand', idBrand);
    const jsonDealer = sessionStorage.getItem('all_dealers_brand_' + idBrand);
    if (jsonDealer) {
      onResponseDealer(JSON.parse(jsonDealer));
    } else {
      uri =
        '/api/lead/getGeocodedDealerByBrand?brand=' + idBrand + '&_format=json';
    }
  }

  callApi({ uri: window.location.origin + sanitizeUri(uri), method: 'GET' })
    .then((response) => {
      document
        .querySelector('.form-lead')
        .querySelector('.loader')
        .classList.remove('active');
      if (response) {
        onResponseDealer(response);
      }
    })
    .catch((e) => {
      /*if (+this.status === 544) {
         dealerError.classList.remove('hide');
         document
           .querySelector('.form-lead')
           .setAttribute('data-dealer-mandatory', 'false');
         checkIfCanSendLead();
       } else {*/
      const notification = document.querySelector('.notification-component');
      notification.querySelector('.title').innerText = 'Errore';
      notification.querySelector('.description').innerText = response.msg;
      notification.classList.add('notification-component--error');
      notification.classList.add('active');
      //}
    });
}

function inizializeFormLead(isComparePage = false) {
  let isInSendMode = false;
  const sourcePayed = drupalSettings.paid_channels
    ? drupalSettings.paid_channels
    : [];
  function clickOnFindPrice() {
    if (document.querySelector('.find-price-btn')) {
      document.querySelectorAll('.find-price-btn').forEach((e) => {
        e.addEventListener('click', (e) => {
          if (
            window.innerWidth < 1024 &&
            !e.currentTarget.classList.contains(`send-request-first-step`) &&
            !e.currentTarget.classList.contains(`send-request-second-step`)
          ) {
            document.querySelector('.toggle-modal-form-lead').click();
          } else {
            document.querySelector('.form-lead').classList.add('fly');
          }
        });
      });
    }
  }

  function removeRelatedTile() {
    const lead = document
      .querySelector('.form-lead')
      .querySelector('.step-2')
      .querySelector('.lead');
    const animationSuccess = document.createElement('div');
    lead.querySelector('.container-cap').classList.remove('active');
    animationSuccess.classList.add('request-success');
    lead.appendChild(animationSuccess);
    animationSuccess.classList.add('active');
    const icon = document.createElement('i');
    icon.classList.add('rcs-icon-check-round');
    icon.classList.add('icon');
    const title = document.createElement('p');
    title.innerText = 'Richiesta inviata';
    title.classList.add('title');
    const description = document.createElement('p');
    description.innerText =
      'Verrai ricontattato per il dettaglio\n' + 'del tuo preventivo.';
    description.classList.add('description');
    animationSuccess.appendChild(icon);
    animationSuccess.appendChild(title);
    animationSuccess.appendChild(description);

    setTimeout(() => {
      lead.classList.add('collapse-lead');
    }, 4000);

    setTimeout(() => {
      lead.parentNode.removeChild(lead);
    }, 4400);
  }

  function getRelatedTileClosed(request, containerName) {
    const uri = '/api/rest/related-push';
    callApi({
      uri: window.location.origin + sanitizeUri(uri),
      method: 'POST',
      data: request,
    })
      .then((response) => {
        if (response.isError) {
          const notification = document.querySelector(
            '.notification-component',
          );
          notification.querySelector('.title').innerText = 'Errore';
          notification.querySelector('.description').innerText =
            response.message;
          notification.classList.add('notification-component--error');
          notification.classList.add('active');
          const formLead = document.querySelector('.form-lead');
          if (formLead) {
            formLead.querySelector('.loader').classList.remove('active');
          }
        } else {
          const container = document
            .querySelector('.form-lead')
            .querySelector('.' + containerName)
            .querySelector('.card-container');
          if (container && response.data && response.data.length > 0) {
            if (document.querySelector('.form-lead .hide-form-text')) {
              document
                .querySelector('.form-lead .hide-form-text')
                .classList.add('margin-top');
            }
            container.innerHTML = '';
            let indexRelatedCar = 1;
            document
              .querySelector('.form-lead')
              .querySelector('.' + containerName)
              .classList.remove('hide');
            response.data.forEach((tile) => {
              const newTile = document.createElement('div');
              newTile.classList.add('card');
              newTile.classList.add('card--offer');
              newTile.classList.add('radius-15');
              newTile.classList.add('card--with-shadow');
              newTile.classList.add('card--bg-white');
              newTile.setAttribute('data-brand-id', +tile.brandId);
              newTile.setAttribute('data-brand-name', tile.brandName);
              newTile.setAttribute('data-model-id', +tile.modelId);
              newTile.setAttribute('data-model-name', tile.modelName);
              newTile.setAttribute('data-push', tile.modelPush);
              newTile.setAttribute('data-variation-id', tile.variationId);
              newTile.setAttribute('data-variation-name', tile.variationName);
              newTile.setAttribute(
                'data-related-car-index',
                'related-index-' + indexRelatedCar,
              );
              newTile.setAttribute(
                'data-dealer-mandatory',
                tile.dealerMandatory,
              );
              newTile.setAttribute('data-promo-name', tile.promoName);
              newTile.setAttribute('data-promo-id', tile.promoId);
              const labelSelectCar = document.querySelector(
                '#form-lead-select-dealer-most-near',
              ).innerText;
              newTile.innerHTML =
                "<div class='card--offer--image-container image-container radius-t-15' style='background-image:url(" +
                tile.image +
                ")'></div><div class='card--offer--content content'> <div class='container-cap'><div class=\"form-field\"></div><span class='text--purple mb-10 select_dealer_label'>" +
                labelSelectCar +
                "</span><div class=\"dealer-container dealer-container-related\"></div></div> <div class='car--details'> <div class='card--offer--content--left'> <span class='card--offer--content--brand'>" +
                (tile.brandName.toLowerCase() === 'cupra' ||
                tile.brandName.toLowerCase() === 'seat'
                  ? tile.brandName.toUpperCase()
                  : tile.brandName) +
                "</span> <span class='card--offer--content--model'>" +
                tile.modelName +
                '</span> </div></div></div>';

              if (tile.editorialBadge && tile.editorialBadge.length > 0) {
                const editorialBadge = document.createElement('div');
                editorialBadge.classList.add('card--badge');
                editorialBadge.classList.add('card--badge--most-visited');
                editorialBadge.classList.add('radius-b-5');
                editorialBadge.innerHTML = tile.editorialBadge;
                newTile.appendChild(editorialBadge);
              }
              if (tile.hasOffer) {
                const hasOffer = document.createElement('div');
                hasOffer.classList.add('card--badge');
                hasOffer.classList.add('card--badge--last-news');
                hasOffer.classList.add('radius-tl-15');
                hasOffer.classList.add('radius-br-15');
                hasOffer.classList.add('text--uppercase');
                hasOffer.innerHTML = document.querySelector(
                  '#cross-site-model-promo-badge',
                ).innerText;
                newTile.appendChild(hasOffer);
              }

              const ctaPreventivo = document.createElement('button');

              ctaPreventivo.classList.add('btn');
              ctaPreventivo.classList.add('btn--sm');
              ctaPreventivo.classList.add('btn--orange');
              ctaPreventivo.classList.add('cta-richiedi-preventivo');
              ctaPreventivo.innerText = 'Richiedi preventivo';
              ctaPreventivo.style.cssText =
                'align-self: flex-end; margin-top: 5px;';

              ctaPreventivo.addEventListener('click', () => {
                window.open(
                  window.location.origin + sanitizeUri(tile.promoUrl),
                );
              });

              container.appendChild(newTile);
              newTile
                .querySelector('.card--offer--content')
                .appendChild(ctaPreventivo);
              indexRelatedCar++;
            });
            window.trigger &&
              window.trigger(document.querySelector('body'), 'getRelatedCars');
          }
          const formLead = document.querySelector('.form-lead');
          if (containerName === 'step-2') {
            formLead.querySelector('.step-1').classList.remove('active');
            formLead.querySelector('.step-2').classList.add('active');
          }
          setTimeout(() => {
            formLead.querySelector('.loader').classList.remove('active');
          }, 500);
        }
      })
      .catch((e) => {
        console.error(e.message);
      });
  }

  function getRelatedTile(request) {
    const uri = '/api/rest/related-push/' + request.modelId;
    callApi({
      uri: window.location.origin + sanitizeUri(uri),
      method: 'GET',
    })
      .then((response) => {
        if (response.isError) {
          const notification = document.querySelector(
            '.notification-component',
          );
          notification.querySelector('.title').innerText = 'Errore';
          notification.querySelector('.description').innerText =
            response.message;
          notification.classList.add('notification-component--error');
          notification.classList.add('active');
          const formLead = document.querySelector('.form-lead');
          if (formLead) {
            formLead.querySelector('.loader').classList.remove('active');
          }
        } else {
          isInSendMode = false;
          const container = document
            .querySelector('.form-lead')
            .querySelector('.step-2')
            .querySelector('.card-container');
          if (container && response.data && response.data.length > 0) {
            container.innerHTML = '';
            let indexRelatedCar = 1;
            response.data.forEach((tile) => {
              const newTile = document.createElement('div');
              newTile.classList.add('card');
              newTile.classList.add('card--offer');
              newTile.classList.add('radius-15');
              newTile.classList.add('card--with-shadow');
              newTile.classList.add('card--bg-white');
              newTile.setAttribute('data-brand-id', +tile.brandId);
              newTile.setAttribute('data-brand-name', tile.brandName);
              newTile.setAttribute('data-model-id', +tile.modelId);
              newTile.setAttribute('data-model-name', tile.modelName);
              newTile.setAttribute('data-push', tile.modelPush);
              newTile.setAttribute('data-variation-id', tile.variationId);
              newTile.setAttribute('data-variation-name', tile.variationName);
              newTile.setAttribute(
                'data-related-car-index',
                'related-index-' + indexRelatedCar,
              );
              newTile.setAttribute(
                'data-dealer-mandatory',
                tile.dealerMandatory,
              );
              newTile.setAttribute('data-promo-name', tile.promoName);
              newTile.setAttribute('data-promo-id', tile.promoId);
              // const imageTile = document.createElement('div');
              // imageTile.classList.add('card--offer--image-container', 'image-container', 'radius-t-15');
              // imageTile.style.cssText = "background-image:url('" + tile.image + "')";
              const labelSelectCar = document.querySelector(
                '#form-lead-select-dealer-most-near',
              ).innerText;
              newTile.innerHTML =
                "<div class='card--offer--image-container image-container radius-t-15' style='background-image:url(" +
                tile.image +
                ')\'></div><div class=\'card--offer--content content\'> <div class=\'container-cap\'><div class="form-field"><input type="number" name="cap" id="cap" class="input" placeholder="cap" maxlength="5" value=' +
                document
                  .querySelector('.form-lead')
                  .querySelector('.step-1')
                  .querySelector('#cap').value +
                '><label for="cap" class="label">Cap</label></div><span class=\'text--purple mb-10 select_dealer_label\'>' +
                labelSelectCar +
                "</span><div class=\"dealer-container dealer-container-related\"></div></div> <div class='car--details'> <div class='card--offer--content--left'> <span class='card--offer--content--brand'>" +
                (tile.brandName.toLowerCase() === 'cupra' ||
                tile.brandName.toLowerCase() === 'seat'
                  ? tile.brandName.toUpperCase()
                  : tile.brandName) +
                "</span> <span class='card--offer--content--model'>" +
                tile.modelName +
                '</span> </div></div></div>';

              if (tile.editorialBadge && tile.editorialBadge.length > 0) {
                const editorialBadge = document.createElement('div');
                editorialBadge.classList.add('card--badge');
                editorialBadge.classList.add('card--badge--most-visited');
                editorialBadge.classList.add('radius-b-5');
                editorialBadge.innerHTML = tile.editorialBadge;
                newTile.appendChild(editorialBadge);
              }
              if (tile.hasOffer) {
                //  clone.querySelector('.card--badge--last-news').classList.remove('hidden');
                const hasOffer = document.createElement('div');
                hasOffer.classList.add('card--badge');
                hasOffer.classList.add('card--badge--last-news');
                hasOffer.classList.add('radius-tl-15');
                hasOffer.classList.add('radius-br-15');
                hasOffer.classList.add('text--uppercase');
                hasOffer.innerHTML = document.querySelector(
                  '#cross-site-model-promo-badge',
                ).innerText;
                newTile.appendChild(hasOffer);
              }

              const ctaPreventivo = document.createElement('button');
              const ctaSend = document.createElement('button');

              ctaPreventivo.classList.add('btn');
              ctaPreventivo.classList.add('btn--sm');
              ctaPreventivo.classList.add('btn--orange');
              ctaPreventivo.classList.add('cta-richiedi-preventivo');
              ctaPreventivo.innerText = 'Richiedi preventivo';
              ctaPreventivo.style.cssText =
                'align-self: flex-end; margin-top: 5px;';

              ctaSend.classList.add('btn');
              ctaSend.classList.add('btn--sm');
              ctaSend.classList.add('btn--orange');
              ctaSend.classList.add('cta-invia-preventivo');
              ctaSend.setAttribute('data-analytics', 'invia-preventivo');

              tile.dealerMandatory === 'true' &&
                ctaSend.classList.add('disabled');
              ctaSend.innerText = 'Invia richiesta';
              ctaSend.style.cssText = 'display: none';

              ctaPreventivo.addEventListener('click', (e) => {
                // fare chiamata per recuperare dealerList

                if (
                  e.currentTarget.parentNode.parentNode.getAttribute(
                    'data-dealer-mandatory',
                  ) &&
                  e.currentTarget.parentNode.parentNode.getAttribute(
                    'data-dealer-mandatory',
                  ) === 'true'
                ) {
                  e.currentTarget.parentNode
                    .querySelector('.select_dealer_label')
                    .classList.add('active');
                  getDealerList(
                    e.currentTarget.parentNode.parentNode.getAttribute(
                      'data-brand-id',
                    ),
                    document
                      .querySelector('.form-lead')
                      .querySelector('.step-1')
                      .querySelector('#cap').value,
                    e.currentTarget.parentNode.parentNode.getAttribute(
                      'data-dealer-geocoded',
                    ),
                  );
                }

                // aggiungere listener su input cap
                newTile.querySelector('#cap').addEventListener('keyup', (e) => {
                  const capRegex = /^[0-9]*$/gm;
                  if (e.currentTarget.value.length > 5) {
                    e.currentTarget.value = e.currentTarget.value.slice(0, 5);
                  }
                  if (
                    !capRegex.test(e.currentTarget.value) ||
                    e.currentTarget.value.length !== 5
                  ) {
                    if (
                      newTile
                        .querySelector('.dealer-container')
                        .classList.contains('active')
                    ) {
                      e.currentTarget.parentNode.parentNode
                        .querySelector('.select_dealer_label')
                        .classList.remove('active');
                      newTile
                        .querySelector('.dealer-container')
                        .classList.remove('active');
                      newTile
                        .querySelector('.dealer-container')
                        .removeAttribute('data-dealer-name');
                      newTile
                        .querySelector('.dealer-container')
                        .removeAttribute('data-dealer-address');
                      newTile
                        .querySelector('.dealer-container')
                        .removeAttribute('data-dealer-id');
                      newTile
                        .querySelector('.dealer-container')
                        .removeAttribute('data-dealer-external-id');
                    }
                    if (!e.currentTarget.classList.contains('invalid')) {
                      e.currentTarget.classList.add('invalid');
                      e.currentTarget.parentNode.parentNode.parentNode
                        .querySelector('.cta-invia-preventivo')
                        .classList.add('disabled');
                    }
                    if (e.currentTarget.classList.contains('valid')) {
                      e.currentTarget.classList.remove('valid');
                    }
                  } else {
                    if (e.currentTarget.classList.contains('invalid')) {
                      e.currentTarget.classList.remove('invalid');
                    }
                    if (!e.currentTarget.classList.contains('valid')) {
                      e.currentTarget.classList.add('valid');
                      // chiamare leads service
                      if (
                        e.currentTarget.parentNode.parentNode.parentNode.parentNode.getAttribute(
                          'data-dealer-mandatory',
                        ) &&
                        e.currentTarget.parentNode.parentNode.parentNode.parentNode.getAttribute(
                          'data-dealer-mandatory',
                        ) === 'true'
                      ) {
                        e.currentTarget.parentNode.parentNode
                          .querySelector('.select_dealer_label')
                          .classList.add('active');
                        const idBrand = newTile.getAttribute('data-brand-id');
                        getDealerList(
                          idBrand,
                          e.currentTarget.value,
                          e.currentTarget.parentNode.parentNode.parentNode.parentNode.getAttribute(
                            'data-dealer-geocoded',
                          ),
                        );
                      } else {
                        e.currentTarget.parentNode.parentNode.parentNode
                          .querySelector('.cta-invia-preventivo')
                          .classList.remove('disabled');
                      }
                    }
                  }
                });
                newTile.querySelector('.container-cap').classList.add('active');
                e.currentTarget.style.cssText = 'display: none';
                e.currentTarget.parentNode.querySelector(
                  '.cta-invia-preventivo',
                ).style.cssText =
                  'display: block; align-self: flex-end; margin-top: 5px;';
                e.currentTarget.parentNode.parentNode.style.cssText =
                  'height: auto';
              });
              window.trigger &&
                window.trigger(
                  document.querySelector('body'),
                  'send-request-created',
                );

              sendRelatedLead(ctaSend);

              container.appendChild(newTile);
              // newTile.insertBefore(imageTile, newTile.querySelector('.card--offer--content'));
              newTile
                .querySelector('.card--offer--content')
                .appendChild(ctaPreventivo);
              newTile
                .querySelector('.card--offer--content')
                .appendChild(ctaSend);
              indexRelatedCar++;
            });
            window.trigger &&
              window.trigger(document.querySelector('body'), 'getRelatedCars');
          }
          const formLead = document.querySelector('.form-lead');
          formLead.querySelector('.step-1').classList.remove('active');
          formLead.querySelector('.step-2').classList.add('active');
          setTimeout(() => {
            formLead.querySelector('.loader').classList.remove('active');
          }, 500);
        }
      })
      .catch((e) => {
        console.error(e.message);
      });
  }

  function createPixel(tag, src, id) {
    const pixelElem = document.getElementById(id);
    const newPixel = !pixelElem ? document.createElement(tag) : pixelElem;
    const hasElem = pixelElem !== null;
    newPixel.setAttribute('src', src);
    newPixel.setAttribute('style', 'border:0;');
    newPixel.setAttribute('width', '1');
    newPixel.setAttribute('height', '1');
    newPixel.setAttribute('id', id);
    if (!hasElem) {
      document.querySelector('body').appendChild(newPixel);
    }
  }

  function getPostbackPixels(promoId, leadId, transactionId) {
    const uri = `/api/form_lead/get_postback_pixels/${transactionId}/${leadId}/${promoId}`;
    callApi({ uri: window.location.origin + sanitizeUri(uri), method: 'GET' })
      .then((response) => {
        console.log(response);
      })
      .catch((e) => {
        console.error(e.message);
      });
  }

  function getPixels(promoId, leadId, brandName) {
    const uri = `/api/form_lead/get_pixels/${promoId}`;
    callApi({ uri: window.location.origin + sanitizeUri(uri), method: 'GET' })
      .then((response) => {
        let awinCreated = false;
        for (let pixel in response) {
          if (response[pixel].type) {
            if (response[pixel].type === 'script' && response[pixel].script) {
              const scriptElem = document.createElement('script');
              scriptElem.setAttribute('id', 'script-' + pixel);
              let scriptHtml = response[pixel].script;
              if (
                response[pixel].variables &&
                response[pixel].variables.length
              ) {
                response[pixel].variables.forEach((value) => {
                  const keys = Object.keys(value);
                  const name = keys.length ? keys[0] : '';
                  scriptHtml = scriptHtml.replaceAll(
                    '_' + name + '_',
                    value[name],
                  );
                });
              }
              scriptElem.text = scriptHtml
                .replace('<script>', '')
                .replace('</script>', '');
              document.querySelector('body').appendChild(scriptElem);
            } else if (response[pixel].url && response[pixel].type) {
              const url = removePlaceholder(response[pixel].url, leadId);
              createPixel(response[pixel].type, url, pixel);
              if (pixel.indexOf('awin') > -1 && !awinCreated) {
                //awin pixel
                if (
                  drupalSettings.pixel_awin &&
                  drupalSettings.pixel_awin.merchant_id &&
                  drupalSettings.pixel_awin.channel &&
                  drupalSettings.pixel_awin.currency &&
                  drupalSettings.pixel_awin.sale_part
                ) {
                  const urlParams = new URLSearchParams(url);
                  const commissionGroupParam = urlParams.get('parts');
                  //<![CDATA[
                  /*** Do not change ***/
                  //let AWIN = {};
                  AWIN.Tracking = {};
                  AWIN.Tracking.Sale = {};

                  /*** Set your transaction parameters ***/
                  AWIN.Tracking.Sale.amount = '1';
                  AWIN.Tracking.Sale.channel =
                    drupalSettings.pixel_awin.channel;
                  AWIN.Tracking.Sale.currency =
                    drupalSettings.pixel_awin.currency;
                  AWIN.Tracking.Sale.orderRef = leadId;
                  AWIN.Tracking.Sale.parts = commissionGroupParam
                    ? commissionGroupParam
                    : drupalSettings.pixel_awin.sale_part.replace(
                        '{brand}',
                        brandName.toUpperCase(),
                      );
                  AWIN.Tracking.Sale.test = '0';
                  //]]>;
                  let nodeElem = document.createElement('script');
                  nodeElem.setAttribute(
                    'src',
                    'https://www.dwin1.com/' +
                      drupalSettings.pixel_awin.merchant_id +
                      '.js',
                  );
                  nodeElem.setAttribute('type', 'text/javascript');
                  nodeElem.setAttribute('async', 'async');
                  nodeElem.setAttribute('defer', 'defer');
                  document.querySelector('body').appendChild(nodeElem);
                  awinCreated = true;
                }
              }
            }
          }
        }
      })
      .catch((e) => {
        console.error(e.message);
      });
  }

  function removePlaceholder(url, leadId) {
    let urlModified = url.replace(/{leadId}/, leadId);
    if (
      drupalSettings.pixel_awin &&
      drupalSettings.pixel_awin.merchant_id &&
      drupalSettings.pixel_awin.channel &&
      drupalSettings.pixel_awin.currency
    ) {
      urlModified = urlModified.replace(
        /{currency}/,
        drupalSettings.pixel_awin.currency,
      );
      urlModified = urlModified.replace(
        /{channel}/,
        drupalSettings.pixel_awin.channel,
      );
      urlModified = urlModified.replace(
        /{merchantId}/,
        drupalSettings.pixel_awin.merchant_id,
      );
      urlModified = urlModified.replace(/{amount}/g, window.priceCriteo);
    }
    return urlModified;
  }

  function onCreateLeadResponse(request, response, isUpselling, firstTime) {
    const formLead = document.querySelector('.form-lead');
    if (response) {
      let campId = localStorage.getItem('cmpid')
        ? localStorage.getItem('cmpid')
        : localStorage.getItem('intcmpid');
      deleteFromLocalStorage('cmpid');
      deleteFromLocalStorage('intcmpid');
      if (getCookie('naturalSearch')) {
        deleteCookie('naturalSearch');
      }
      const promoId = formLead.getAttribute('data-promo-id');
      if (!isUpselling) {
        getPixels(
          !!promoId ? promoId : 0,
          response.leadId,
          request.leadPurpose && request.leadPurpose.toUpperCase() === 'RENTAL'
            ? request.rentalOperator
            : request.brandName,
        );
      }
      const url = new URL(location.href);
      const urlParams = new URLSearchParams(url.search);
      if (urlParams.has('transaction_id') && !isUpselling) {
        getPostbackPixels(
          !!promoId ? promoId : 0,
          response.leadId,
          urlParams.get('transaction_id'),
        );
      }
      startSalesCriteo(response.leadId, request.cap);

      //PIXELS
      try {
        if (
          drupalSettings.facebookApiConverter.facebookTrackingEnabled &&
          drupalSettings.facebookApiConverter.facebookUrlIp &&
          drupalSettings.facebookApiConverter.facebook_pixel_1 &&
          drupalSettings.facebookApiConverter.facebook_pixel_2
        ) {
          if (typeof fbq !== 'undefined') {
            if (campId && campId.indexOf('newaccount') >= 0) {
              //second pixel
              fbq(
                'trackSingle',
                drupalSettings.facebookApiConverter.facebook_pixel_2,
                'Lead',
                {},
                { eventID: 'Lead.' + response.leadId },
              );
            } else {
              //first pixel
              fbq(
                'trackSingle',
                drupalSettings.facebookApiConverter.facebook_pixel_1,
                'Lead',
                {},
                { eventID: 'Lead.' + response.leadId },
              );
            }
          }
        }

        gtag('event', 'conversion', {
          send_to: 'AW-676572607/EFtHCIW8ysQBEL_bzsIC',
        });
        // Bing Pixel
        if (
          drupalSettings.bing &&
          drupalSettings.bing.uet_id &&
          drupalSettings.bing.url &&
          drupalSettings.bing.tag
        ) {
          let bingId = drupalSettings.bing.uet_id;
          let bingUrl = drupalSettings.bing.url;
          let bingTag = drupalSettings.bing.tag;
          (function (w, d, t, r, u) {
            let f, n, i;
            (w[u] = w[u] || []),
              (f = function () {
                let o = { ti: bingId };
                (o.q = w[u]), (w[u] = new UET(o)), w[u].push('pageLoad');
              }),
              (n = d.createElement(t)),
              (n.src = r),
              (n.async = 1),
              (n.onload = n.onreadystatechange =
                function () {
                  let s = this.readyState;
                  (s && s !== 'loaded' && s !== 'complete') ||
                    (f(), (n.onload = n.onreadystatechange = null));
                }),
              (i = d.getElementsByTagName(t)[0]),
              i.parentNode.insertBefore(n, i);
          })(window, document, 'script', bingUrl, bingTag);
        }
      } catch (e) {
        console.error(e);
      }

      if (
        firstTime &&
        response.success &&
        formLead.querySelector('.step-1').classList.contains('active')
      ) {
        formLead.setAttribute('parent-lead', response.leadId);
        const reqRelated = {
          parentLead: response.leadId,
          modelId: request.modelId,
          modelPush: request.modelPush,
          motornetId: request.motornetId,
        };
        getRelatedTile(reqRelated);
      } else if (response.success && !firstTime) {
        //rimuovi card per cui hai fatto lead
        removeRelatedTile();
      } else if (!response.success) {
        const notification = document.querySelector('.notification-component');
        notification.querySelector('.title').innerText = 'Errore';
        if (response.error) {
          notification.querySelector('.description').innerText = response.error;
        } else if (response.message) {
          notification.querySelector('.description').innerText =
            response.message;
        }
        notification.classList.add('notification-component--error');
        notification.classList.add('active');
        formLead.querySelector('.loader').classList.remove('active');
      }
      const $secondStep = formLead.querySelector('.send-request-second-step');
      if ($secondStep) {
        $secondStep.removeEventListener('click', () => {});
        $secondStep.addEventListener('click', (e) => {
          if (!e.currentTarget.classList.contains('inizialized')) {
            e.currentTarget.classList.add('inizialized');
          }
          formLead.querySelector('.step-2').classList.remove('active');
          formLead.querySelector('.step-3').classList.add('active');
          eventOnRadioButton();
          eventOnLastStep();
        });
      }

      isInSendMode = false;
    } else {
      isInSendMode = false;
    }
    setTimeout(() => {
      formLead.querySelector('.loader').classList.remove('active');
    }, 500);
  }

  function createLead(request, firstTime, isUpselling = false) {
    const uri = window.location.origin + '/api/lead/createLead';
    const formLead = document.querySelector('.form-lead');
    if (!firstTime) {
      request.motornetId = '';
    }
    let campId = localStorage.getItem('cmpid')
      ? localStorage.getItem('cmpid')
      : localStorage.getItem('intcmpid');
    let pixelId = '';
    if (campId && campId.indexOf('newaccount') >= 0) {
      //second pixel
      pixelId = drupalSettings.facebookApiConverter.facebook_pixel_2;
    } else {
      //first pixel
      pixelId = drupalSettings.facebookApiConverter.facebook_pixel_1;
    }
    const idEvent = Date.now();
    const idEventSha = SHA256('' + idEvent);
    if (
      !getCookie('publicIp') ||
      getCookie('publicIp').split('=').length <= 1
    ) {
      jQuery.get(
        drupalSettings.facebookApiConverter &&
          drupalSettings.facebookApiConverter.facebookUrlIp
          ? drupalSettings.facebookApiConverter.facebookUrlIp
          : 'https://api.ipify.org',
        function (dataApi) {
          createCookieWithValue('publicIp', dataApi, 60);
          const data = {
            ...request,
            facebookEnabled:
              drupalSettings.facebookApiConverter &&
              drupalSettings.facebookApiConverter.facebookTrackingEnabled,
            facebookPayload:
              drupalSettings.facebookApiConverter &&
              drupalSettings.facebookApiConverter.facebookTrackingEnabled
                ? {
                    referrer: window.location.href,
                    eventName: 'Lead',
                    userAgent: navigator.userAgent,
                    pixelId,
                    ip: data,
                    externalId: idEventSha,
                    fbp:
                      getCookie('_fbp') &&
                      getCookie('_fbp').split('=').length > 1
                        ? getCookie('_fbp').split('=')[1]
                        : '',
                    fbc:
                      getCookie('_fbc') &&
                      getCookie('_fbc').split('=').length > 1
                        ? getCookie('_fbc').split('=')[1]
                        : '',
                  }
                : {},
          };
          callApi({
            uri,
            method: 'POST',
            data,
          })
            .then((responseText) => {
              onCreateLeadResponse(
                request,
                responseText,
                isUpselling,
                firstTime,
              );
            })
            .catch((e) => {
              setTimeout(() => {
                formLead.querySelector('.loader').classList.remove('active');
                isInSendMode = false;
              }, 500);

              const notification = document.querySelector(
                '.notification-component',
              );
              notification.querySelector('.title').innerText = 'Errore';
              notification.querySelector('.description').innerText = e;
              notification.classList.add('notification-component--error');
              notification.classList.add('active');
            });
        },
      );
    } else {
      const data = {
        ...request,
        facebookEnabled:
          drupalSettings.facebookApiConverter &&
          drupalSettings.facebookApiConverter.facebookTrackingEnabled,
        facebookPayload:
          drupalSettings.facebookApiConverter &&
          drupalSettings.facebookApiConverter.facebookTrackingEnabled
            ? {
                referrer: window.location.href,
                eventName: 'Lead',
                userAgent: navigator.userAgent,
                pixelId,
                ip: getCookie('publicIp').split('=')[1],
                externalId: idEventSha,
                fbp:
                  getCookie('_fbp') && getCookie('_fbp').split('=').length > 1
                    ? getCookie('_fbp').split('=')[1]
                    : '',
                fbc:
                  getCookie('_fbc') && getCookie('_fbc').split('=').length > 1
                    ? getCookie('_fbc').split('=')[1]
                    : '',
              }
            : {},
      };
      callApi({
        uri,
        method: 'POST',
        data,
      })
        .then((responseText) => {
          onCreateLeadResponse(request, responseText, isUpselling, firstTime);
        })
        .catch((e) => {
          setTimeout(() => {
            formLead.querySelector('.loader').classList.remove('active');
            isInSendMode = false;
          }, 500);

          const notification = document.querySelector(
            '.notification-component',
          );
          notification.querySelector('.title').innerText = 'Errore';
          notification.querySelector('.description').innerText = e;
          notification.classList.add('notification-component--error');
          notification.classList.add('active');
        });
    }
  }

  function sendRelatedLead(ctaSend) {
    const callBack = (e) => {
      ctaSend.removeEventListener('click', callBack);

      // fare chiamata per altra lead
      const card = ctaSend.parentNode.parentNode;

      let canSend = false;
      if (
        e.currentTarget.parentNode.parentNode.getAttribute(
          'data-dealer-mandatory',
        ) &&
        e.currentTarget.parentNode.parentNode.getAttribute(
          'data-dealer-mandatory',
        ) === 'true'
      ) {
        e.currentTarget.parentNode
          .querySelector('.container-cap')
          .querySelector('.dealer-container')
          .querySelectorAll('div')
          .forEach((dealer) => {
            if (dealer.classList.contains('active')) {
              canSend = true;
            }
          });
      } else {
        canSend =
          e.currentTarget.parentNode.querySelector('input').value.length === 5;
      }

      let showPrefixPhone = document
        .querySelector('.form-lead')
        .querySelector('#set-prefix-phone-number')
        ? document
            .querySelector('.form-lead')
            .querySelector('#set-prefix-phone-number')
            .classList.contains('setprefixphone')
        : false;
      document
        .querySelector('.form-lead .form')
        .querySelectorAll('input')
        .forEach((el) => {
          controlFormInput(
            el,
            el.getAttribute('id'),
            blacklistMail,
            showPrefixPhone,
          );
        });
      const valid = checkIfCanSendLead();
      if (canSend && !isInSendMode && valid) {
        const md = new MobileDetect(window.navigator.userAgent);
        isInSendMode = true;
        let device = 'desktop';
        if (md.phone()) {
          device = 'mobile';
        } else if (md.tablet()) {
          device = 'tablet';
        }
        window.masterKeyFull.device = device;

        const urlParams = new URLSearchParams(window.location.search);
        if (getCookie('naturalSearch')) {
          window.masterKeyFull.source = 'natural-search';
        }
        let intcmpid = urlParams.get('intcmpid');
        if (!intcmpid && localStorage.getItem('intcmpid')) {
          intcmpid = localStorage.getItem('intcmpid');
        }
        if (intcmpid) {
          window.masterKeyFull.full_query = 'intcmpid=' + intcmpid;
          intcmpid = intcmpid.split('_');
          window.masterKeyFull.source = intcmpid[0];
          window.masterKeyFull.publisher = intcmpid[8];
          window.masterKeyFull.media_crm_campaign_id = intcmpid[6];
          window.masterKeyFull.media_crm_campaign = intcmpid[9];
        }
        let cmpid = urlParams.get('cmpid');
        if (!cmpid && localStorage.getItem('cmpid')) {
          cmpid = localStorage.getItem('cmpid');
        }
        if (cmpid) {
          window.masterKeyFull.full_query = 'cmpid=' + cmpid;
          cmpid = cmpid.split('_');
          window.masterKeyFull.source = cmpid[0];
          window.masterKeyFull.publisher = cmpid[8];
          window.masterKeyFull.media_crm_campaign_id = cmpid[6];
          window.masterKeyFull.media_crm_campaign = cmpid[9];
        }

        let isSourcePayed = sourcePayed.some((el) => {
          return window.masterKeyFull.source.toLowerCase() === el.toLowerCase();
        });

        if (isSourcePayed) {
          window.masterKeyFull.level0 = 'Paid';
        }

        let cap = e.currentTarget.parentNode
          .querySelector('.container-cap')
          .querySelector('#cap').value
          ? e.currentTarget.parentNode
              .querySelector('.container-cap')
              .querySelector('#cap').value
          : '';
        if (cap && cap.length < 5) {
          while (cap.length < 5) {
            cap = '0' + cap;
          }
        }

        //upselling form new masterkey
        window.masterKeyFull['level1'] = 'UpsellingForm';

        const formLead = document.querySelector('.form-lead');
        const req = {
          parentLead: +formLead.getAttribute('parent-lead'),
          firstName: formLead.querySelector('.step-1').querySelector('#name')
            .value
            ? formLead
                .querySelector('.step-1')
                .querySelector('#name')
                .value.replaceAll('\t', ' ')
                .replaceAll('\n', ' ')
                .replaceAll('\r', ' ')
                .trim()
            : null,
          lastName: formLead.querySelector('.step-1').querySelector('#surname')
            .value
            ? formLead
                .querySelector('.step-1')
                .querySelector('#surname')
                .value.replaceAll('\t', ' ')
                .replaceAll('\n', ' ')
                .replaceAll('\r', ' ')
                .trim()
            : null,
          email: formLead.querySelector('.step-1').querySelector('#email').value
            ? formLead
                .querySelector('.step-1')
                .querySelector('#email')
                .value.replaceAll('\t', ' ')
                .replaceAll('\n', ' ')
                .replaceAll('\r', ' ')
                .trim()
            : null,
          phoneNumber: formLead.querySelector('.step-1').querySelector('#tel')
            .value
            ? formLead
                .querySelector('.step-1')
                .querySelector('#tel')
                .value.replaceAll('\t', ' ')
                .replaceAll('\n', ' ')
                .replaceAll('\r', ' ')
                .trim()
            : null,
          cap: cap,
          section: formLead.getAttribute('data-section-name'),
          dealerName: card
            .querySelector('.dealer-container')
            .getAttribute('data-dealer-name')
            ? card
                .querySelector('.dealer-container')
                .getAttribute('data-dealer-name')
            : null,
          dealerAddress: card
            .querySelector('.dealer-container')
            .getAttribute('data-dealer-address')
            ? card
                .querySelector('.dealer-container')
                .getAttribute('data-dealer-address')
            : null,
          brandId: card.getAttribute('data-brand-id')
            ? +card.getAttribute('data-brand-id')
            : null,
          modelId: card.getAttribute('data-model-id')
            ? +card.getAttribute('data-model-id')
            : null,
          variationId: card.getAttribute('data-variation-id')
            ? +card.getAttribute('data-variation-id')
            : null,
          promoId: card.getAttribute('data-promo-id')
            ? card.getAttribute('data-promo-id')
            : null,
          motornetId: formLead.getAttribute('data-motornet-id'),
          modelPush: card.getAttribute('data-push')
            ? card.getAttribute('data-push')
            : null,
          modelName: card.getAttribute('data-model-name')
            ? card.getAttribute('data-model-name')
            : null,
          brandName: card.getAttribute('data-brand-name')
            ? card.getAttribute('data-brand-name')
            : null,
          promoName: card.getAttribute('data-promo-name')
            ? card.getAttribute('data-promo-name')
            : null,
          variationName: card.getAttribute('data-variation-name')
            ? card.getAttribute('data-variation-name')
            : null,
          leadPurpose: card.getAttribute('data-offer-purpose-name')
            ? card.getAttribute('data-offer-purpose-name')
            : 'Selling',
          rentalOperator: card.getAttribute('data-rental-operator-name')
            ? card.getAttribute('data-rental-operator-name')
            : null,
          masterKey: Object.values(window.masterKeyFull).join('|'),
        };
        e.currentTarget.parentNode.parentNode.classList.add('lead');
        formLead.querySelector('.loader').classList.add('active');
        if (
          card.getAttribute('data-brand-name') &&
          card.getAttribute('data-brand-name').toUpperCase().indexOf('SUBARU') >
            -1
        ) {
          req.brandMarketingConsent = '1';
        }
        createLead(req, false, true);
      } else if (!valid) {
        isInSendMode = false;
      }
    };

    ctaSend.addEventListener('click', callBack);
  }

  let isSendLastStepActive = false;
  function updateFormLead(request) {
    if (!isSendLastStepActive) {
      isSendLastStepActive = true;
      const uri = '/api/lead/updateLead';
      callApi({
        uri: window.location.origin + sanitizeUri(uri),
        method: 'POST',
        data: request,
      })
        .then((response) => {
          if (response.success) {
            const formLead = document.querySelector('.form-lead');
            formLead.querySelector('.step-completed').classList.add('active');
            setTimeout(() => {
              formLead.classList.remove('fly');
            }, 3000);
            formLead.querySelector('.step-3').classList.remove('active');
          }
          isSendLastStepActive = false;
        })
        .catch((e) => {
          console.error(e.message);
          isSendLastStepActive = false;
        });
    }
  }

  function eventOnLastStep() {
    const formLead = document.querySelector('.form-lead');
    formLead
      .querySelector('.step-3')
      .querySelector('.cta-send-last-step')
      .addEventListener('click', (e) => {
        //form completed

        e.preventDefault();
        e.stopPropagation();
        if (!e.currentTarget.classList.contains('inizialized')) {
          e.currentTarget.classList.add('inizialized');
        }
        let req = {
          parentLead:
            +e.currentTarget.parentNode.parentNode.parentNode.getAttribute(
              'parent-lead',
            ),
        };
        e.currentTarget.parentNode.querySelectorAll('form').forEach((f) => {
          f.querySelectorAll('input').forEach((i) => {
            if (i.checked) {
              req[f.getAttribute('id')] = i.getAttribute('data-label');
            }
          });
        });

        // send update api service
        updateFormLead(req);
      });
  }

  function eventOnRadioButton() {
    const formLead = document.querySelector('.form-lead');
    formLead
      .querySelector('.step-3')
      .querySelectorAll('input')
      .forEach((radio) => {
        radio.addEventListener('click', (e) => {
          e.currentTarget.parentNode.parentNode
            .querySelectorAll('input')
            .forEach((b) => {
              if (b !== e.currentTarget) {
                b.checked = false;
              }
            });
        });
      });
  }

  function sendFirstStep() {
    if (document.querySelector('.form-lead')) {
      const cta = document
        .querySelector('.form-lead')
        .querySelector('.send-request-first-step');
      cta.addEventListener('click', () => {
        let showPrefixPhone = document
          .querySelector('.form-lead')
          .querySelector('#set-prefix-phone-number')
          ? document
              .querySelector('.form-lead')
              .querySelector('#set-prefix-phone-number')
              .classList.contains('setprefixphone')
          : false;
        document
          .querySelector('.form-lead .form')
          .querySelectorAll('input')
          .forEach((el) => {
            controlFormInput(
              el,
              el.getAttribute('id'),
              blacklistMail,
              showPrefixPhone,
            );
          });
        const valid = checkIfCanSendLead();
        if (!isInSendMode && valid) {
          isInSendMode = true;
          const formLead = document.querySelector('.form-lead');
          formLead.querySelector('.loader').classList.add('active');
          let request = {};
          const md = new MobileDetect(window.navigator.userAgent);
          let device = 'desktop';
          if (md.phone()) {
            device = 'mobile';
          } else if (md.tablet()) {
            device = 'tablet';
          }
          window.masterKeyFull.device = device;

          const urlParams = new URLSearchParams(window.location.search);
          if (getCookie('naturalSearch')) {
            window.masterKeyFull.source = 'natural-search';
          }
          let intcmpid = urlParams.get('intcmpid');
          if (!intcmpid && localStorage.getItem('intcmpid')) {
            intcmpid = localStorage.getItem('intcmpid');
          }
          if (intcmpid) {
            window.masterKeyFull.full_query = 'intcmpid=' + intcmpid;
            intcmpid = intcmpid.split('_');
            window.masterKeyFull.source = intcmpid[0];
            window.masterKeyFull.publisher = intcmpid[8];
            window.masterKeyFull.media_crm_campaign_id = intcmpid[6];
            window.masterKeyFull.media_crm_campaign = intcmpid[9];
          }
          let cmpid = urlParams.get('cmpid');
          if (!cmpid && localStorage.getItem('cmpid')) {
            cmpid = localStorage.getItem('cmpid');
          }
          const cmpidFB = cmpid;
          if (cmpid) {
            window.masterKeyFull.full_query = 'cmpid=' + cmpid;
            cmpid = cmpid.split('_');
            window.masterKeyFull.source = cmpid[0];
            window.masterKeyFull.publisher = cmpid[8];
            window.masterKeyFull.media_crm_campaign_id = cmpid[6];
            window.masterKeyFull.media_crm_campaign = cmpid[9];
          }

          let isSourcePayed = sourcePayed.some((el) => {
            return (
              window.masterKeyFull.source.toLowerCase() === el.toLowerCase()
            );
          });

          if (isSourcePayed) {
            window.masterKeyFull.level0 = 'Paid';
          }

          let cap = formLead.querySelector('.step-1').querySelector('#cap')
            .value
            ? formLead.querySelector('.step-1').querySelector('#cap').value
            : '';
          if (cap && cap.length < 5) {
            while (cap.length < 5) {
              cap = '0' + cap;
            }
          }

          //upselling mail new masterkey
          const urlSearchParams = new URLSearchParams(window.location.search);
          const params = Object.fromEntries(urlSearchParams.entries());
          if (params['upselling']) {
            window.masterKeyFull['level1'] = 'UpsellingMail';
          } else if (params['upsellingFormClosed']) {
            window.masterKeyFull['level1'] = 'upsellingFormClosed';
          }
          if (cmpidFB && cmpidFB.indexOf('facebook_leadads') > -1) {
            window.masterKeyFull['level1'] = 'UpsellingLeadsADS';
          }

          const dealerSelection = {};

          document
            .querySelectorAll('.dealer-container')
            .forEach((dealerContainer) => {
              if (!dealerSelection['name']) {
                dealerSelection['name'] =
                  dealerContainer.getAttribute('data-dealer-name');
                dealerSelection['address'] = dealerContainer.getAttribute(
                  'data-dealer-address',
                );
                dealerSelection['external_id'] = dealerContainer.getAttribute(
                  'data-dealer-external-id',
                );
              }
            });

          if (
            formLead.querySelector('#haveInsurance') &&
            formLead.querySelector('#haveInsurance').checked
          ) {
            request = {
              firstName: formLead
                .querySelector('.step-1')
                .querySelector('#name').value
                ? formLead
                    .querySelector('.step-1')
                    .querySelector('#name')
                    .value.replaceAll('\t', ' ')
                    .replaceAll('\n', ' ')
                    .replaceAll('\r', ' ')
                    .trim()
                : null,
              lastName: formLead
                .querySelector('.step-1')
                .querySelector('#surname').value
                ? formLead
                    .querySelector('.step-1')
                    .querySelector('#surname')
                    .value.replaceAll('\t', ' ')
                    .replaceAll('\n', ' ')
                    .replaceAll('\r', ' ')
                    .trim()
                : null,
              email: formLead.querySelector('.step-1').querySelector('#email')
                .value
                ? formLead
                    .querySelector('.step-1')
                    .querySelector('#email')
                    .value.replaceAll('\t', ' ')
                    .replaceAll('\n', ' ')
                    .replaceAll('\r', ' ')
                    .trim()
                : null,
              phoneNumber: formLead
                .querySelector('.step-1')
                .querySelector('#tel').value
                ? formLead
                    .querySelector('.step-1')
                    .querySelector('#tel')
                    .value.replaceAll('\t', ' ')
                    .replaceAll('\n', ' ')
                    .replaceAll('\r', ' ')
                    .trim()
                : null,
              cap: cap,
              section: formLead.getAttribute('data-section-name'),
              dealerName: dealerSelection['name'],
              dealerAddress: dealerSelection['address'],
              dealerId: dealerSelection['external_id'],
              brandId: formLead.getAttribute('data-brand-id')
                ? +formLead.getAttribute('data-brand-id')
                : null,
              modelId: formLead.getAttribute('data-model-id')
                ? +formLead.getAttribute('data-model-id')
                : null,
              variationId: formLead.getAttribute('data-variation-id')
                ? +formLead.getAttribute('data-variation-id')
                : null,
              promoId: formLead.getAttribute('data-promo-id')
                ? +formLead.getAttribute('data-promo-id')
                : null,
              motornetId: formLead.getAttribute('data-motornet-id'),
              modelPush: formLead.getAttribute('data-push')
                ? formLead.getAttribute('data-push')
                : null,
              additional: {
                insurance: formLead
                  .querySelector('.step-1')
                  .querySelector('#haveInsurance').checked
                  ? formLead
                      .querySelector('.step-1')
                      .querySelector('#haveInsurance').checked
                  : null,
                codiceFiscale: formLead
                  .querySelector('.step-1')
                  .querySelector('#cf').value
                  ? formLead.querySelector('.step-1').querySelector('#cf').value
                  : null,
              },
              brandName: formLead.getAttribute('data-brand-name')
                ? formLead.getAttribute('data-brand-name')
                : null,
              variationName: formLead.getAttribute('data-variation-name')
                ? formLead.getAttribute('data-variation-name')
                : null,
              promoName: formLead.getAttribute('data-promo-name')
                ? formLead.getAttribute('data-promo-name')
                : null,
              modelName: formLead.getAttribute('data-model-name')
                ? formLead.getAttribute('data-model-name')
                : null,
              leadPurpose: formLead.getAttribute('data-offer-purpose-name')
                ? formLead.getAttribute('data-offer-purpose-name')
                : 'Selling',
              rentalOperator: formLead.getAttribute('data-rental-operator-name')
                ? formLead.getAttribute('data-rental-operator-name')
                : null,
              masterKey: Object.values(window.masterKeyFull).join('|'),
              relatedModel: cta.getAttribute('data-related-model'),
            };
          } else {
            request = {
              firstName: formLead
                .querySelector('.step-1')
                .querySelector('#name').value
                ? formLead
                    .querySelector('.step-1')
                    .querySelector('#name')
                    .value.replaceAll('\t', ' ')
                    .replaceAll('\n', ' ')
                    .replaceAll('\r', ' ')
                    .trim()
                : null,
              lastName: formLead
                .querySelector('.step-1')
                .querySelector('#surname').value
                ? formLead
                    .querySelector('.step-1')
                    .querySelector('#surname')
                    .value.replaceAll('\t', ' ')
                    .replaceAll('\n', ' ')
                    .replaceAll('\r', ' ')
                    .trim()
                : null,
              email: formLead.querySelector('.step-1').querySelector('#email')
                .value
                ? formLead
                    .querySelector('.step-1')
                    .querySelector('#email')
                    .value.replaceAll('\t', ' ')
                    .replaceAll('\n', ' ')
                    .replaceAll('\r', ' ')
                    .trim()
                : null,
              phoneNumber: formLead
                .querySelector('.step-1')
                .querySelector('#tel').value
                ? formLead
                    .querySelector('.step-1')
                    .querySelector('#tel')
                    .value.replaceAll('\t', ' ')
                    .replaceAll('\n', ' ')
                    .replaceAll('\r', ' ')
                    .trim()
                : null,
              cap: cap,
              section: formLead.getAttribute('data-section-name'),
              dealerName: dealerSelection['name'],
              dealerAddress: dealerSelection['address'],
              dealerId: dealerSelection['external_id'],
              brandId: formLead.getAttribute('data-brand-id')
                ? +formLead.getAttribute('data-brand-id')
                : null,
              modelId: formLead.getAttribute('data-model-id')
                ? +formLead.getAttribute('data-model-id')
                : null,
              variationId: formLead.getAttribute('data-variation-id')
                ? +formLead.getAttribute('data-variation-id')
                : null,
              promoId: formLead.getAttribute('data-promo-id')
                ? +formLead.getAttribute('data-promo-id')
                : null,
              motornetId: formLead.getAttribute('data-motornet-id'),
              modelPush: formLead.getAttribute('data-push')
                ? formLead.getAttribute('data-push')
                : null,
              brandName: formLead.getAttribute('data-brand-name')
                ? formLead.getAttribute('data-brand-name')
                : null,
              modelName: formLead.getAttribute('data-model-name')
                ? formLead.getAttribute('data-model-name')
                : null,
              variationName: formLead.getAttribute('data-variation-name')
                ? formLead.getAttribute('data-variation-name')
                : null,
              promoName: formLead.getAttribute('data-promo-name')
                ? formLead.getAttribute('data-promo-name')
                : null,
              leadPurpose: formLead.getAttribute('data-offer-purpose-name')
                ? formLead.getAttribute('data-offer-purpose-name')
                : 'Selling',
              rentalOperator: formLead.getAttribute('data-rental-operator-name')
                ? formLead.getAttribute('data-rental-operator-name')
                : null,
              masterKey: Object.values(window.masterKeyFull).join('|'),
              relatedModel: cta.getAttribute('data-related-model'),
            };

            if (
              document
                .querySelector('#form-lead')
                .querySelector('.marketing-box')
            ) {
              const checkboxes = document
                .querySelector('#form-lead')
                .querySelector('.marketing-box')
                .querySelectorAll('input[type="checkbox"]');
              const bmwBrand = ['bmw', 'mini', 'lotus'];
              let isBmwBrand = false;
              bmwBrand.forEach((b) => {
                if (request.brandName.toLowerCase() === b) {
                  isBmwBrand = true;
                  return true;
                }
              });

              for (const checkbox of checkboxes) {
                const checkboxId = checkbox.getAttribute('id');
                if (isBmwBrand) {
                  request[checkboxId] = checkbox.classList.contains('checked')
                    ? 1
                    : checkbox.getAttribute('data-change-value') === '1'
                    ? 0
                    : null;
                } else {
                  request[checkboxId] = checkbox.classList.contains('checked')
                    ? 1
                    : 0;
                }
              }
            }

            if (
              document.querySelector('#form-lead').querySelector('.privacy-box')
            ) {
              const privacyOptions = document
                .querySelector('#form-lead')
                .querySelector('.privacy-box')
                .querySelectorAll('.privacy-options');
              for (const privacyOption of privacyOptions) {
                const value = privacyOption.getAttribute('data-value');
                const ids = privacyOption.getAttribute('data-ids');
                const arrayIds = ids ? ids.split(';') : [];
                for (const id of arrayIds) {
                  request[id] = value;
                }
              }
            }
          }
          createLead(request, true, params['upselling'] === '1');
        } else if (!valid) {
          isInSendMode = false;
        }
      });
    }
  }

  function controlFormInput(el, type, blacklistMail, showPrefixPhone) {
    switch (type) {
      case 'name':
        const nameError = document.querySelector('.form .error-name');
        if (el.value.length < 2) {
          if (!el.classList.contains('invalid')) {
            el.classList.add('invalid');
          }
          if (el.classList.contains('valid')) {
            el.classList.remove('valid');
          }
          nameError.classList.add('active');
        } else {
          if (el.classList.contains('invalid')) {
            el.classList.remove('invalid');
          }
          if (!el.classList.contains('valid')) {
            el.classList.add('valid');
          }
          nameError.classList.remove('active');
        }
        break;
      case 'surname':
        const surnameError = document.querySelector('.form .error-surname');
        if (el.value.length < 2) {
          if (!el.classList.contains('invalid')) {
            el.classList.add('invalid');
          }
          if (el.classList.contains('valid')) {
            el.classList.remove('valid');
          }
          surnameError.classList.add('active');
        } else {
          if (el.classList.contains('invalid')) {
            el.classList.remove('invalid');
          }
          if (!el.classList.contains('valid')) {
            el.classList.add('valid');
          }
          surnameError.classList.remove('active');
        }
        break;
      case 'email':
        const emailRegex =
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const blacklistMailElement =
          document.querySelector('.form .error-email');
        if (!emailRegex.test(el.value)) {
          blacklistMailElement.classList.add('active');
          if (!el.classList.contains('invalid')) {
            el.classList.add('invalid');
          }
          if (el.classList.contains('valid')) {
            el.classList.remove('valid');
          }
        } else {
          blacklistMailElement.classList.remove('active');
          if (el.classList.contains('invalid')) {
            el.classList.remove('invalid');
          }
          if (!el.classList.contains('valid')) {
            el.classList.add('valid');
          }

          const domain = el.value.split('@')[1] || '';
          const isBlacklisted = blacklistMail.filter(
            (mail) => mail.toLowerCase() === domain.toLowerCase(),
          );
          if (isBlacklisted.length > 0) {
            blacklistMailElement.classList.add('active');
            el.classList.add('invalid');
            el.classList.remove('valid');
          } else {
            blacklistMailElement.classList.remove('active');
            el.classList.remove('invalid');
            el.classList.add('valid');
          }
        }
        break;
      case 'tel':
        const errorPhoneElem = document.querySelector('.form .error-phone');
        let telRegex = /^[0-9+]{9,13}$/gi;
        if (showPrefixPhone) {
          if (el.value.length < 3) {
            el.value = '+39';
          }
          telRegex = /^(\+39)[0-9]{9,13}$/gi;
        }
        if (!telRegex.test(el.value)) {
          errorPhoneElem.classList.add('active');
          if (!el.classList.contains('invalid')) {
            el.classList.add('invalid');
          }
          if (el.classList.contains('valid')) {
            el.classList.remove('valid');
          }
        } else {
          errorPhoneElem.classList.remove('active');
          if (el.classList.contains('invalid')) {
            el.classList.remove('invalid');
          }
          if (!el.classList.contains('valid')) {
            el.classList.add('valid');
          }
        }
        break;
      case 'cf':
        const cfRegex =
          /^([A-Za-z]{6}[0-9lmnpqrstuvLMNPQRSTUV]{2}[abcdehlmprstABCDEHLMPRST]{1}[0-9lmnpqrstuvLMNPQRSTUV]{2}[A-Za-z]{1}[0-9lmnpqrstuvLMNPQRSTUV]{3}[A-Za-z]{1})$|([0-9]{11})$/g;
        if (!cfRegex.test(el.value)) {
          if (!el.classList.contains('invalid')) {
            el.classList.add('invalid');
          }
          if (el.classList.contains('valid')) {
            el.classList.remove('valid');
          }
        } else {
          if (el.classList.contains('invalid')) {
            el.classList.remove('invalid');
          }
          if (!el.classList.contains('valid')) {
            el.classList.add('valid');
          }
        }
        break;
      case 'cap':
        const capError = document.querySelector('.form .error-cap');
        const capRegex = /^[0-9]*$/gm;
        if (el.value.length > 5) {
          el.value = el.value.slice(0, 5);
        }
        if (!capRegex.test(el.value) || el.value.length !== 5) {
          document
            .querySelector('.form-lead')
            .querySelectorAll('.dealer-container')
            .forEach((dealerContainer) => {
              if (dealerContainer.classList.contains('active')) {
                dealerContainer.classList.remove('active');
                dealerContainer.removeAttribute('data-dealer-name');
                dealerContainer.removeAttribute('data-dealer-address');
                dealerContainer.removeAttribute('data-dealer-external-id');
                dealerContainer.removeAttribute('data-dealer-id');
              }
            });

          if (
            document
              .querySelector('.form-lead')
              .querySelector('.select_dealer_label')
              .classList.contains('active')
          ) {
            document
              .querySelector('.form-lead')
              .querySelector('.select_dealer_label')
              .classList.remove('active');
          }
          capError.classList.add('active');

          if (!el.classList.contains('invalid')) {
            el.classList.add('invalid');
          }

          if (el.classList.contains('valid')) {
            el.classList.remove('valid');
          }

          const dealerError = document
            .querySelector('.form-lead')
            .querySelector('.dealer-locator-error-container');
          if (dealerError) {
            dealerError.classList.add('hide');
          }
        } else {
          if (el.classList.contains('invalid')) {
            el.classList.remove('invalid');
          }
          capError.classList.remove('active');

          if (!el.classList.contains('valid')) {
            el.classList.add('valid');
            // chiamare leads service
            if (dealerMandatoryBrand === 'true') {
              const idBrand = document
                .querySelector('.form-lead')
                .getAttribute('data-brand-id');
              getDealerList(
                idBrand,
                el.value,
                document
                  .querySelector('.form-lead')
                  .getAttribute('data-dealer-geocoded'),
              );
            }
          }
        }
        break;
      default:
        break;
    }
  }

  function toggleCheckboxInsurance() {
    if (
      document.querySelector('.form-lead') &&
      document.querySelector('.form-lead').querySelector('.checkbox-container')
    ) {
      const checkbox = document
        .querySelector('.form-lead')
        .querySelector('.checkbox-container')
        .querySelector('input');
      checkbox.addEventListener('change', (e) => {
        document
          .querySelector('.form-lead')
          .querySelector('.insurance-box')
          .querySelector('.form-field')
          .classList.toggle('active');
        checkIfCanSendLead();
      });
    }
  }

  function toggleMarketingAccordion() {
    if (
      document.querySelector('.form-lead') &&
      document
        .querySelector('.form-lead')
        .querySelectorAll('.checkbox-accordion').length
    ) {
      const checkboxButtons = document
        .querySelector('.form-lead')
        .querySelectorAll('.checkbox-accordion');
      checkboxButtons.forEach((checkboxButton) => {
        checkboxButton.addEventListener('click', (button) => {
          const accordionName =
            button.currentTarget.getAttribute('data-action-id');
          document
            .querySelector('.form-lead')
            .querySelector(
              '.accordion[data-accordion-name="' + accordionName + '"]',
            )
            .classList.toggle('isShow');
        });
      });
    }
  }

  let blacklistMail = [];
  function initFormLead() {
    if (document.querySelector('.form-lead')) {
      const form = document.querySelector('.form-lead').querySelector('.form');
      if (document.querySelector('.form-lead').querySelector('.form-visible')) {
        blacklistMail =
          drupalSettings.blackList && drupalSettings.blackList.length > 0
            ? drupalSettings.blackList
            : [];
        form.querySelector('#tel').addEventListener('click', (e) => {
          const el = e.currentTarget;
          let showPrefixPhone = form.querySelector('#set-prefix-phone-number')
            ? form
                .querySelector('#set-prefix-phone-number')
                .classList.contains('setprefixphone')
            : false;
          controlFormInput(
            el,
            el.getAttribute('id'),
            blacklistMail,
            showPrefixPhone,
          );
        });
        form.querySelectorAll('input').forEach((input) => {
          input.addEventListener('keyup', (e) => {
            const el = e.currentTarget;
            let showPrefixPhone = form.querySelector('#set-prefix-phone-number')
              ? form
                  .querySelector('#set-prefix-phone-number')
                  .classList.contains('setprefixphone')
              : false;
            controlFormInput(
              el,
              el.getAttribute('id'),
              blacklistMail,
              showPrefixPhone,
            );
            checkIfCanSendLead();
          });
          input.addEventListener('click', () => startBasketCriteo());
        });

        if (
          document.querySelector('.form-lead').querySelector('.insurance-box')
        ) {
          document
            .querySelector('.form-lead')
            .querySelector('.insurance-box')
            .querySelector('.form-field')
            .querySelector('#tel')
            .addEventListener('click', (e) => {
              const el = e.currentTarget;
              let showPrefixPhone = form.querySelector(
                '#set-prefix-phone-number',
              )
                ? form
                    .querySelector('#set-prefix-phone-number')
                    .classList.contains('setprefixphone')
                : false;
              controlFormInput(
                el,
                el.getAttribute('id'),
                blacklistMail,
                showPrefixPhone,
              );
              checkIfCanSendLead();
            });
          document
            .querySelector('.form-lead')
            .querySelector('.insurance-box')
            .querySelector('.form-field')
            .querySelector('input')
            .addEventListener('keyup', (e) => {
              const el = e.currentTarget;
              let showPrefixPhone = form.querySelector(
                '#set-prefix-phone-number',
              )
                ? form
                    .querySelector('#set-prefix-phone-number')
                    .classList.contains('setprefixphone')
                : false;
              controlFormInput(
                el,
                el.getAttribute('id'),
                blacklistMail,
                showPrefixPhone,
              );
              checkIfCanSendLead();
            });
        }
      }
    }
  }

  function openModalForm() {
    const btns = document.querySelectorAll('.toggle-modal-form-lead');
    btns.forEach((btn) => {
      btn.addEventListener('click', function () {
        const form = document.querySelector('.form-content');
        form.classList.toggle('active');
        if (form.parentNode.classList.contains('fly'))
          form.parentNode.classList.remove('fly');
      });
    });
  }

  //getRegex();
  openModalForm();
  initFormLead();
  checkIfCanSendLead();
  toggleCheckboxInsurance();
  sendFirstStep();
  clickOnFindPrice();
  toggleMarketingAccordion();
  if (!isComparePage) {
    getPrivacyForm();
  } else {
    let loaders = document
      .querySelector('.form-lead')
      .querySelectorAll('.loader');
    for (const loader of loaders) {
      loader.classList.add('compare');
    }
  }

  if (document.querySelector('.hide-form')) {
    getRelatedTileClosed(
      {
        modelId: document
          .querySelector('.form-lead')
          .getAttribute('data-model-id'),
        excludeOwnBrand: false,
      },
      'upselling-form-closed',
    );
  }
}

executeOnce('form-lead', function () {
  inizializeFormLead();
});

function checkIfCanSendLead(formElem = '') {
  let formLead = !formElem
    ? document.querySelector('.form-lead')
    : document.querySelector(formElem);
  if (formLead) {
    const form = formLead.querySelector('.form');
    let canSend = true;
    form.querySelectorAll('input:not([type="radio"])').forEach((input) => {
      if (!input.classList.contains('valid')) {
        canSend = false;
        formLead
          .querySelector('.send-request-first-step')
          .classList.add('disabled');
      }
    });

    if (formLead.querySelector('.marketing-box.validate-form')) {
      formLead
        .querySelector('.marketing-box.validate-form')
        .querySelectorAll('input')
        .forEach((input) => {
          if (!input.classList.contains('valid')) {
            canSend = false;
            formLead
              .querySelector('.send-request-first-step')
              .classList.add('disabled');
          }
        });
    }

    if (formLead.querySelector('.privacy-box.validate-form')) {
      formLead
        .querySelector('.privacy-box.validate-form')
        .querySelectorAll('.privacy-options')
        .forEach((privacy) => {
          if (privacy.getAttribute('data-valid') !== 'true') {
            canSend = false;
            formLead
              .querySelector('.send-request-first-step')
              .classList.add('disabled');
          }
        });
    }

    if (
      canSend &&
      formLead.getAttribute('data-dealer-mandatory') &&
      formLead.getAttribute('data-dealer-mandatory') === 'true'
    ) {
      canSend = false;
      formLead
        .querySelectorAll('.dealer-container')
        .forEach((dealerContainer) => {
          dealerContainer.querySelectorAll('div').forEach((dealer) => {
            if (dealer.classList.contains('active')) {
              canSend = true;
              return;
            }
          });
          if (canSend) {
            return;
          }
        });
    }

    // if(document.querySelector('.form-lead').getAttribute('data-dealer-mandatory') && document.querySelector('.form-lead').getAttribute('data-dealer-mandatory') === 'true'){
    if (formLead.querySelector('.checkbox-container')) {
      const checkbox = formLead
        .querySelector('.checkbox-container')
        .querySelector('input');
      if (!checkbox.classList.contains('checked')) {
        if (canSend) {
          formLead
            .querySelector('.send-request-first-step')
            .classList.remove('disabled');
        } else {
          formLead
            .querySelector('.send-request-first-step')
            .classList.add('disabled');
        }
      } else {
        formLead
          .querySelector('.send-request-first-step')
          .classList.add('disabled');
        //  do some
        if (
          formLead
            .querySelector('.insurance-box')
            .querySelector('.form-field')
            .querySelector('.input')
            .classList.contains('valid')
        ) {
          canSend = true;
          formLead
            .querySelector('.send-request-first-step')
            .classList.remove('disabled');
        } else {
          canSend = false;
          formLead
            .querySelector('.send-request-first-step')
            .classList.add('disabled');
        }
      }
    } else {
      canSend
        ? formLead
            .querySelector('.send-request-first-step')
            .classList.remove('disabled')
        : formLead
            .querySelector('.send-request-first-step')
            .classList.add('disabled');
    }

    const checkboxGroups = formLead.querySelectorAll('.checkbox-group');
    if (checkboxGroups && checkboxGroups.length) {
      canSend = true;
      checkboxGroups.forEach((checkboxGroup) => {
        let hasFlagChecked = false;
        checkboxGroup.querySelector('.error-group').classList.remove('active');
        if (
          checkboxGroup.hasAttribute('data-mandatory') &&
          checkboxGroup.getAttribute('data-mandatory') === 'true'
        ) {
          const flags = checkboxGroup.querySelectorAll('.checkbox-button');
          flags.forEach((flag) => {
            if (flag.querySelector('input').classList.contains('checked')) {
              hasFlagChecked = true;
            }
          });
          if (!hasFlagChecked) {
            canSend = false;
            checkboxGroup.querySelector('.error-group').classList.add('active');
          }
        }
      });
    }
    return canSend;
  }
  return false;
  // }
}

function startBasketCriteo() {
  if (!criteoTriggered && drupalSettings.criteo.account_id) {
    criteoTriggered = true;
    window.criteo_q = window.criteo_q || [];
    let deviceType = /iPad/.test(navigator.userAgent)
      ? 't'
      : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(
          navigator.userAgent,
        )
      ? 'm'
      : 'd';
    window.criteo_q.push(
      {
        event: 'setAccount',
        account: parseInt(drupalSettings.criteo.account_id),
      },
      {
        event: 'setEmail',
        email: drupalSettings.criteo.email ? drupalSettings.criteo.email : '',
      },
      { event: 'setSiteType', type: deviceType },
      {
        event: 'viewBasket',
        item: [
          {
            id: window.modelCriteo,
            price: window.priceCriteo,
            quantity: 1,
          },
        ],
      },
    );
  }
}

function startSalesCriteo(leadId, cap) {
  if (drupalSettings.criteo.account_id) {
    window.criteo_q = window.criteo_q || [];
    let deviceType = /iPad/.test(navigator.userAgent)
      ? 't'
      : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(
          navigator.userAgent,
        )
      ? 'm'
      : 'd';
    window.criteo_q.push(
      {
        event: 'setAccount',
        account: parseInt(drupalSettings.criteo.account_id),
      },
      {
        event: 'setEmail',
        email: drupalSettings.criteo.email ? drupalSettings.criteo.email : '',
      },
      { event: 'setZipcode', zipcode: cap },
      { event: 'setSiteType', type: deviceType },
      {
        event: 'trackTransaction',
        id: leadId,
        item: [
          {
            id: window.modelCriteo,
            price: window.priceCriteo,
            quantity: 1,
          },
        ],
      },
    );
  }
}

let dealerMandatoryBrand = 'false';
let forceSchedule = false;

function selectCheckbox(e) {
  const target = e.currentTarget;
  const input = target.querySelector('input');
  const fakeInput = target.querySelector('.custom-checkbox');
  input.click();
  input.classList.toggle('checked');
  fakeInput.classList.toggle('checked');
  checkIfCanSendLead();
}

function getPrivacyForm(isCompare = false, formElem = '') {
  let form = !formElem
    ? document.querySelector('.form-lead')
    : document.querySelector(formElem);

  if (form && form.getAttribute('data-brand-name')) {
    const brand = form.getAttribute('data-brand-name');
    const promoId = form.getAttribute('data-promo-id');
    const modelName = form.getAttribute('data-model-name');
    let uri = '/api/form_lead/get_privacy_form/' + brand + '?_format=json';
    if (promoId) {
      uri =
        '/api/form_lead/get_privacy_form/' +
        brand +
        '?offerId=' +
        promoId +
        (modelName.toLowerCase().indexOf('megane') > -1
          ? '&model=megane'
          : '') +
        '&_format=json';
    }

    callApi({ uri: window.location.origin + sanitizeUri(uri), method: 'GET' })
      .then((response) => {
        let privacyTemplate = `
            <div class="privacy-box-item">
              <div class="privacy-text no-accordion"></div>
              <div class="radio-accordion hidden">
                <div class="radio-accordion-header">
                <div class="flex-1">
                  <span class="privacy-title"></span>
                </div>
                    <div class="btn-accordion mx-10">
                      <i class="rcs-icon-arrow-down"></i>
                    </div>
                  </div>
                <span class="privacy-text accordion" data-accordion-name="marketing-communication"></span>
              </div>
              <div class="privacy-options">
                  <label class="privacy-options-item">
                     <input type="radio" name="privacy-option-radio" value="1" style="display: none;">
                     <span class="custom-privacy-option-radio"></span>
                     <span class="custom-privacy-option-radio-text"></span>
                  </label>
                  <label class="privacy-options-item">
                     <input type="radio" name="privacy-option-radio" value="0" style="display: none;">
                     <span class="custom-privacy-option-radio"></span>
                     <span class="custom-privacy-option-radio-text"></span>
                  </label>
              </div>
            </div>
          `;

        let privacyBox = form.querySelector('.privacy-box');

        if (privacyBox) {
          let child = privacyBox.lastElementChild;
          form.querySelector('#privacy-brand').innerHTML = '';
          if (form.querySelector('#privacy-partner')) {
            form
              .querySelector('#privacy-partner')
              .setAttribute('href', '/informativa_privacy_partner/');
          }
          while (child) {
            privacyBox.removeChild(child);
            child = privacyBox.lastElementChild;
          }
          privacyBox.style.display = 'none';
        }

        if (
          response.privacy_multi_options &&
          response.privacy_multi_options.length
        ) {
          for (const elem of response.privacy_multi_options) {
            let elemHtml = document.createElement('div');
            privacyTemplate = privacyTemplate.trim();
            elemHtml.innerHTML = privacyTemplate.replace(
              /name="privacy-option-radio"/g,
              'name="privacy-option-radio-' +
                elem.id.toString().replace(/,/g, ';') +
                '"',
            );

            if (elem.has_accordion) {
              let radioAccordion = elemHtml.querySelector('.radio-accordion');
              radioAccordion.classList.remove('hidden');
              elemHtml.querySelector('.privacy-text.no-accordion').remove();

              let accordionText = radioAccordion.querySelector('.privacy-text');
              let accordionButton =
                radioAccordion.querySelector('.btn-accordion');
              radioAccordion.classList.remove('hidden');
              radioAccordion.querySelector('.privacy-title').innerHTML =
                elem.accordion_title;
              accordionButton.addEventListener('click', () => {
                radioAccordion.classList.toggle('active');
                accordionButton.classList.toggle('click');
                if (!!radioAccordion.classList.contains('active')) {
                  accordionText.innerHTML = elem.accordion_text;
                } else {
                  accordionText.innerHTML = '';
                }
              });
            } else {
              elemHtml.querySelector('.privacy-text.no-accordion').innerHTML =
                elem.mandatory ? `${elem.text}*` : elem.text;
            }

            let privacyOptions = elemHtml.querySelector('.privacy-options');
            if (privacyOptions) {
              privacyOptions.setAttribute('data-mandatory', elem.mandatory);
              privacyOptions.setAttribute('data-valid', !elem.mandatory);
              privacyOptions.setAttribute(
                'data-ids',
                elem.id.toString().replace(/,/g, ';'),
              );

              const privacyItems = privacyOptions.querySelectorAll(
                '.privacy-options-item .custom-privacy-option-radio-text',
              );
              if (privacyItems) {
                for (const [index, privacyItem] of privacyItems.entries()) {
                  privacyItem.innerHTML =
                    index === 0 ? elem.agree : index === 1 ? elem.disagree : '';
                }
              }
            }

            const radios = elemHtml.querySelectorAll('input[type="radio"]');
            if (radios) {
              for (const radio of radios) {
                radio.addEventListener(
                  'change',
                  (e) => {
                    const {
                      target: { value },
                    } = e;
                    privacyOptions.setAttribute('data-value', value);
                    privacyOptions.setAttribute('data-valid', true);
                    checkIfCanSendLead(formElem);
                    e.stopPropagation();
                  },
                  false,
                );
              }
            }

            if (privacyBox) {
              privacyBox.appendChild(elemHtml.firstChild);
              privacyBox.style.display = 'block';

              if (!privacyBox.classList.contains('validate-form')) {
                privacyBox.classList.add('validate-form');
              }
            }
          }
        }

        let checkboxTemplate = `
              <div class="checkbox-button" data-action-id="marketing-communication">
                <div class="checkbox-element">
                   <div class="custom-checkbox-container">
                     <input type="checkbox" id="marketingConsent" style="display: none;">
                     <div class="custom-checkbox"></div>
                   </div>
                   <div class="checkbox-accordion hidden">
                      <div class="checkbox-accordion-header">
                      <div class="flex-1">
                        <span class="checkbox-accordion-title"></span>
                      </div>
                         <div class="btn-accordion mx-10">
                            <i class="rcs-icon-arrow-down"></i>
                         </div>
                       </div>
                     <span class="checkbox-accordion-text" data-accordion-name="marketing-communication"></span>
                   </div>
                   <div class="checkbox-standard">
                     <span class="checkbox-title" data-accordion-name="marketing-communication"></span>
                   </div>
                </div>
              </div>
          `;

        let checkboxContainer = form.querySelector('.marketing-box');
        if (checkboxContainer) {
          let child = checkboxContainer.lastElementChild;
          form.querySelector('#privacy-brand').innerHTML = '';
          if (form.querySelector('#privacy-partner')) {
            form
              .querySelector('#privacy-partner')
              .setAttribute('href', '/informativa_privacy_partner/');
          }
          while (child) {
            checkboxContainer.removeChild(child);
            child = checkboxContainer.lastElementChild;
          }
          checkboxContainer.style.display = 'none';
        }

        if (response.privacy_options && response.privacy_options.length) {
          for (const elem of response.privacy_options) {
            let template = document.createElement('template');
            let elemHtml = document.createElement('div');
            checkboxTemplate = checkboxTemplate.trim();
            elemHtml.innerHTML = checkboxTemplate;
            template.appendChild(elemHtml);

            elemHtml
              .querySelector('.checkbox-button')
              .setAttribute('data-action-id', elem.id);
            elemHtml
              .querySelector("input[type='checkbox']")
              .setAttribute('id', elem.id);
            elemHtml
              .querySelector("input[type='checkbox']")
              .addEventListener('click', (e) => {
                e.currentTarget.setAttribute('data-change-value', '1');
                e.stopPropagation();
              });

            let label = elem.label;
            if (elem.mandatory) {
              label = '* ' + elem.label;
              elemHtml
                .querySelector("input[type='checkbox']")
                .setAttribute('data-mandatory', elem.mandatory);
            } else {
              elemHtml
                .querySelector("input[type='checkbox']")
                .classList.add('valid');
            }
            elemHtml.querySelector('.checkbox-title').innerHTML =
              elem.accordion_text;

            if (elem.has_accordion) {
              let checkBoxAccordion = elemHtml.querySelector(
                '.checkbox-accordion',
              );
              let accordionText = elemHtml.querySelector(
                '.checkbox-accordion-text',
              );
              let accordionButton = elemHtml.querySelector('.btn-accordion');
              checkBoxAccordion.classList.remove('hidden');
              elemHtml
                .querySelector('.checkbox-standard')
                .classList.add('hidden');
              elemHtml.querySelector('.checkbox-accordion-title').innerHTML =
                elem.accordion_title;
              accordionButton.addEventListener('click', () => {
                checkBoxAccordion.classList.toggle('active');
                accordionButton.classList.toggle('click');
                if (!!checkBoxAccordion.classList.contains('active')) {
                  //if (!!accordionButton.classList.toggle('click')){
                  accordionText.innerHTML = elem.accordion_text;
                } else {
                  accordionText.innerHTML = '';
                }
              });
            }

            if (checkboxContainer) {
              checkboxContainer.appendChild(elemHtml.firstChild);
              checkboxContainer.style.display = 'block';

              if (!checkboxContainer.classList.contains('validate-form')) {
                checkboxContainer.classList.add('validate-form');
              }
            }
          }

          if (form && form.querySelector('.marketing-box')) {
            const checkboxes = document
              .querySelector('.form-lead')
              .querySelector('.marketing-box')
              .querySelectorAll('input[type="checkbox"]');
            for (const checkbox of checkboxes) {
              checkbox.addEventListener('click', (e) => {
                startBasketCriteo();
                const mandatory =
                  e.currentTarget.getAttribute('data-mandatory') === 'true';
                if (mandatory) {
                  e.currentTarget.classList.toggle('valid');
                }
                checkIfCanSendLead(formElem);
                e.stopPropagation();
              });
            }
          }
        }

        //privacy group
        if (response.privacy_groups && response.privacy_groups.length) {
          let checkboxGroupTemplate = `
                <p class="checkbox-group-title"></p>
                <div class="checkbox-flags"></div>
                <div class="error-group error-text-label">Seleziona almeno 1 valore</div>
            `;
          for (const group of response.privacy_groups) {
            let elemGroupHtml = document.createElement('div');
            elemGroupHtml.classList.add('checkbox-group');
            elemGroupHtml.innerHTML = checkboxGroupTemplate;
            elemGroupHtml.setAttribute('data-mandatory', group.mandatory);
            elemGroupHtml.querySelector('.checkbox-group-title').innerText =
              group.title;
            for (const elem of group.flags) {
              let template = document.createElement('template');
              let elemHtml = document.createElement('div');
              checkboxTemplate = checkboxTemplate.trim();
              elemHtml.innerHTML = checkboxTemplate;
              template.appendChild(elemHtml);

              elemHtml
                .querySelector('.checkbox-button')
                .setAttribute('data-action-id', elem.id);
              elemHtml
                .querySelector("input[type='checkbox']")
                .setAttribute('id', elem.id);
              elemHtml
                .querySelector("input[type='checkbox']")
                .addEventListener('click', (e) => {
                  e.currentTarget.setAttribute('data-change-value', '1');
                  e.stopPropagation();
                });

              let label = elem.label;
              if (elem.mandatory) {
                label = '* ' + elem.label;
                elemHtml
                  .querySelector("input[type='checkbox']")
                  .setAttribute('data-mandatory', elem.mandatory);
              } else {
                elemHtml
                  .querySelector("input[type='checkbox']")
                  .classList.add('valid');
              }
              elemHtml.querySelector('.checkbox-title').innerHTML =
                elem.accordion_text;

              if (elemGroupHtml) {
                elemGroupHtml
                  .querySelector('.checkbox-flags')
                  .appendChild(elemHtml.firstChild);
                elemGroupHtml.style.display = 'block';

                if (!elemGroupHtml.classList.contains('validate-form')) {
                  elemGroupHtml.classList.add('validate-form');
                }
              }
            }
            if (checkboxContainer) {
              checkboxContainer.appendChild(elemGroupHtml);
              checkboxContainer.style.display = 'block';

              if (!checkboxContainer.classList.contains('validate-form')) {
                checkboxContainer.classList.add('validate-form');
              }
            }
          }
        }

        // Custom Checkbox
        if (form && form.querySelectorAll('.custom-checkbox-container')) {
          let customCheckboxes = form.querySelectorAll(
            '.custom-checkbox-container',
          );
          for (let customCheckbox of customCheckboxes) {
            // touchstart and click event handler
            customCheckbox.addEventListener('click', (e) => {
              e.preventDefault();
              selectCheckbox(e);
            });

            customCheckbox.addEventListener('touchstart', (e) => {
              e.preventDefault();
              selectCheckbox(e);
            });
          }
        }

        // check if flag set prefix phone number is true and set class for add +39 into phone field
        if (form.querySelector('#set-prefix-phone-number')) {
          if (
            response.set_prefix_phone_number &&
            response.set_prefix_phone_number.value == 1
          ) {
            form
              .querySelector('#set-prefix-phone-number')
              .classList.add('setprefixphone');
          } else {
            form
              .querySelector('#set-prefix-phone-number')
              .classList.remove('setprefixphone');
          }
        }

        if (response.dealer_mandatory_brand) {
          dealerMandatoryBrand = response.dealer_mandatory_brand;
        }

        if (response.force_enable_dl) {
          forceSchedule = response.force_enable_dl;
        }

        if (response.dealer_mandatory) {
          form.setAttribute('data-dealer-mandatory', response.dealer_mandatory);
          form.setAttribute('data-dealer-geocoded', response.dealer_geocoded);
          if (
            form.querySelector('.dealer-container') &&
            form.querySelector('.dealer-container').classList.contains('active')
          ) {
            form.querySelector('.dealer-container').classList.remove('active');
          }

          if (
            form.querySelector('.select_dealer_label') &&
            form
              .querySelector('.select_dealer_label')
              .classList.contains('active')
          ) {
            form
              .querySelector('.select_dealer_label')
              .classList.remove('active');
          }

          form
            .querySelector('.dealer-container')
            .removeAttribute('data-dealer-name');
          form
            .querySelector('.dealer-container')
            .removeAttribute('data-dealer-address');
          form
            .querySelector('.dealer-container')
            .removeAttribute('data-dealer-external-id');

          if (
            response.dealer_mandatory === 'true' &&
            form.querySelector('.step-1').querySelector('#cap').value &&
            form.querySelector('.step-1').querySelector('#cap').value.length ===
              5
          ) {
            getDealerList(
              form.getAttribute('data-brand-id'),
              form.querySelector('.step-1').querySelector('#cap').value,
              response.dealer_geocoded,
            );
          }
        }

        if (response.custom_thankyou_lead_text) {
          form.querySelector('.step-2').innerHTML =
            response.custom_thankyou_lead_text;
        }

        if (response.hide_other_step_button) {
          form.querySelector('.step-2 .send-request-second-step').remove();
        }

        if (
          response.informativa_pre_options &&
          form.querySelector('#privacy-pre-options')
        ) {
          form.querySelector('#privacy-pre-options').innerHTML =
            response.informativa_pre_options;
        } else {
          form.querySelector('#privacy-pre-options').innerHTML = '';
        }

        if (
          response.informativa_brand_text &&
          form.querySelector('#privacy-brand')
        ) {
          form.querySelector('#privacy-brand').innerHTML =
            response.informativa_brand_text;
        }
        if (
          response.informativa_brand_header &&
          form.querySelector('#privacy-header')
        ) {
          form.querySelector('#privacy-header').innerHTML =
            response.informativa_brand_header;
        }
        if (response.cta_button_label && form.querySelector('#send-lead')) {
          form.querySelector('#send-lead').innerHTML =
            response.cta_button_label;
        }

        if (response.form_title) {
          form.querySelector('.form-content--title').innerText =
            response.form_title;
        }

        if (isCompare) {
          const modal = document.querySelector('.modal-form-lead');
          modal.classList.add('active');
        }
      })
      .catch((e) => {
        console.error(e.message);
      });
  }
}
